import { render, staticRenderFns } from "./article.vue?vue&type=template&id=1ec8487b&scoped=true&lang=pug&"
import script from "./article.vue?vue&type=script&lang=js&"
export * from "./article.vue?vue&type=script&lang=js&"
import style0 from "./article.vue?vue&type=style&index=0&id=1ec8487b&lang=scss&scoped=true&"
import style1 from "./article.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./article.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec8487b",
  null
  
)

export default component.exports